/**
 * Formats a number in Indian numbering system
 * Format: C,CCC,LL,00,000
 * Where C = Crores (10,000,000), L = Lakhs (100,000)
 * 
 * Example: 94961250 becomes 9,49,61,250
 */
export const formatIndianCurrency = (amount) => {
  if (!amount && amount !== 0) return '0';
  
  // Convert to string and split into integer and decimal parts
  const numStr = amount?.toString();
  const parts = numStr?.split('.');
  let integerPart = parts?.[0];
  const decimalPart = parts?.[1] ? `.${parts?.[1]}` : '';
  
  // Handle negative numbers
  const isNegative = integerPart?.startsWith('-');
  if (isNegative) {
    integerPart = integerPart?.substring(1);
  }
  
  // If number is less than 1000, no formatting needed
  if (integerPart?.length <= 3) {
    return `${isNegative ? '-' : ''}${integerPart}${decimalPart}`;
  }
  
  // Get last 3 digits
  const lastThree = integerPart?.substring(integerPart?.length - 3);
  
  // Get remaining digits
  const remaining = integerPart?.substring(0, integerPart?.length - 3);
  
  // Format remaining digits in groups of 2 (for lakhs and crores)
  const formattedRemaining = remaining?.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
  
  // Combine with last three digits
  const formattedNumber = `${formattedRemaining},${lastThree}`;
  
  return `${isNegative ? '-' : ''}${formattedNumber}${decimalPart}`;
};

/**
 * Formats amount with INR symbol and Indian numbering
 * @param {number} amount - Amount to format
 * @param {boolean} includeDecimals - Whether to include decimal places (default: true)
 */
export const formatINR = (amount, includeDecimals = true) => {
  if (!amount && amount !== 0) return '₹0';
  
  const formattedAmount = includeDecimals 
    ? formatIndianCurrency(amount?.toFixed(2))
    : formatIndianCurrency(Math.round(amount));
  
  return `₹${formattedAmount}`;
};